import isFinite from 'lodash/isFinite';

// use browser locale (change to 'de-DE' for "." separated thousands)
const locale = undefined;

/**
 * Format currency based on currencyCode and locale
 *
 * @param {string} key
 * @returns string
 */
export function format(value, currencyCode, options = {}) {
  if (!currencyCode || !isFinite(value)) {
    // do not attempt to format when no currency code is provided
    // or value is not a finite number
    return value;
  }

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    maximumFractionDigits: 8,
    ...options,
  }).format(value);
}

export default {
  format,
};
